function visibleNumber(value) {
    let str_value = value.toString()
    var n = parseInt(str_value.replaceAll(/ /g, ""), 10);
    n = n.toLocaleString().replaceAll(",", " ");
    if (n) {
      return n;
    } else {
      return 0;
    }
}

function maskPhoneNumber(number) {
  const cleaned = number.replace(/\D/g, ''); // Faqat raqamlarni saqlaydi
  if (cleaned.startsWith('82')) {
      return cleaned.replace(/^82(\d{2})(\d{4})(\d{4})$/, '+82 $1 $2 $3');
  }
  return number; // Format noto‘g‘ri bo‘lsa, o‘zgartirmaydi
}

const version = '2.0.1';
export {visibleNumber, maskPhoneNumber, version}